import React from 'react';

function Footer() {
  return (
    <footer className="main__container footer">
      <h2 className="footer__copyright">© {new Date().getFullYear()} Alrededor de los EEUU</h2>
    </footer>
  );
}

export default Footer;
